<!-- TODO: add context help id for 'Add Tile' -->
<mat-dialog-content titleText="Add Dashboard Tile">
  <div mat-dialog-title class="dialog-header">
    <h3 class="dialog-title">Add Dashboard Tile</h3>
    <button type="button" mat-icon-button tabindex="-1" (click)="onCloseClick()"> <mat-icon>close</mat-icon></button>
  </div>
  <div dialog-content>
    <lcs-loading-overlay [show]="callState | lcsCallState : 'loading'">
      <mat-tab-group (selectedIndexChange)="onTabChange($event)">
        <mat-tab label="Gallery">
          <mat-tab-group
            class="designer-tiles-group headerless-tab-group"
            [selectedIndex]="selectedDesignerTileSetType ? 1 : 0"
            >
            <mat-tab>
              <div class="add-tile-tab">
                <div class="find">
                  <mat-form-field>
                    <mat-label>Find</mat-label>
                    <input
                      autocomplete="off"
                      type="text"
                      matInput
                      [ngModel]="searchText"
                      (ngModelChange)="onSearchTextChange($event)"
                      name="search-input"
                      />
                      <mat-icon matSuffix class="list-search-icon">search</mat-icon>
                    </mat-form-field>
                  </div>
                  @if (tileSets?.length > 0 || (callState | lcsCallState : 'loading')) {
                    <div
                      class="tiles"
                      cdkScrollable
                      >
                      @for (tileSet of tileSets; track tileSet) {
                        <ng-container
                                 *ngTemplateOutlet="
                                    designerTileTemplate;
                                    context: {
                                       tileSet: tileSet
                                    }
                                 "
                      ></ng-container>
                    }
                    <ng-template #designerTileTemplate let-tileSet="tileSet">
                      <ndt-tile-card-view
                        [types]="getTileSetTypes(tileSet)"
                        [description]="tileSet.description"
                        [designerDescription]="tileSet.designerDescription"
                        (cardClick)="onNextDesignerTileSet(tileSet)"
                        >
                      </ndt-tile-card-view>
                    </ng-template>
                  </div>
                } @else {
                  No Tiles Found.
                }
              </div>
            </mat-tab>
            <mat-tab>
              <div class="add-tile-tab designer-tile-configuration">
                @if (selectedDesignerTileSetType) {
                  <ndt-add-dashboard-tile-form
                    [tile]="selectedDesignerTileSetType.tile"
                    [tileSet]="selectedDesignerTileSet"
                    [callState]="callState"
                    (back)="onNextDesignerTileSet(null)"
                    (submit)="onAddTile($event)"
                    (tileSetTypeChange)="onDesignerTileSetTypeChange($event)"
                  ></ndt-add-dashboard-tile-form>
                }
              </div>
            </mat-tab>
          </mat-tab-group>
        </mat-tab>
      </mat-tab-group>
    </lcs-loading-overlay>
  </div>
</mat-dialog-content>
